import {
  Box,
  Grid,
  Button,
  IconButton,
  Typography,
  Tabs,
  Tab,
  ListItem,
  List,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from "@mui/material";

import React, { useState } from "react";
import banner1 from "../assets/banner1.png";
import banner2 from "../assets/banner2.png";
import image from "../assets/image4.png";
import ucg from "../assets/ucg.png";
import MicIcon from "@mui/icons-material/Mic";
import { motion } from "framer-motion";
import l1 from "../assets/l1.png";
import l2 from "../assets/l2.webp";
import l3 from "../assets/l3.webp";
import l4 from "../assets/l4.webp";
import l5 from "../assets/l5.webp";
import l6 from "../assets/l6.webp";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Header from "./Header";
import Footer from "./Footer";

const videoId = "M_a4GYGtYHM?si=MwbfkrAJ9lhilVDB";

const highlights = [
  {
    title: "Flexible Learning",
    desc: "Study astrology at your own pace without attending physical classes.",
  },
  {
    title: "Affordable Fees",
    desc: "The IGNOU astrology course fee structure is budget-friendly.",
  },
  {
    title: "Expert Faculty",
    desc: "Learn from experienced astrology scholars and professionals.",
  },
  {
    title: "Recognized Course",
    desc: "A valid certification enhances career prospects in astrology.",
  },
  {
    title: "Practical Training",
    desc: "Gain hands-on experience in horoscope reading and analysis.",
  },
];
const accreditations = [
  {
    img: ucg,
    title: "UCG Entitled",
    desc: "Recognized by the University Grants Commission",
  },
  {
    img: ucg,
    title: "Grade NAAC A++ Accredited",
    desc: "Accredited by the National Assessment and Accreditation Council",
  },
  {
    img: ucg,
    title: "AICTE Approved",
    desc: "Approved by the All India Council for Technical Education",
  },
  {
    img: ucg,
    title: "MHRD Approved",
    desc: "Ministry of Human Resource Development",
  },
  {
    img: ucg,
    title: "WES Accredited",
    desc: "World Education System",
  },
  {
    img: ucg,
    title: "AIU Approved",
    desc: "Recognized by the Association of Indian Universities",
  },
];
const learningItems = [
  { img: l1, title: "E-books Study Material" },
  { img: l2, title: "Live Interactive Sessions" },
  { img: l3, title: "Project & Assignment" },
  { img: l4, title: "Learning Management" },
  { img: l5, title: "Top Studies Center" },
  { img: l6, title: "Worldwide Reach" },
];
const faqData = [
  {
    question: "What is the IGNOU Online Astrology course?",
    answer:
      "The IGNOU Online & Distance Astrology course is designed for beginners and enthusiasts to learn astrology from scratch.",
  },
  {
    question: "How can I enroll in the course?",
    answer:
      "Submit your contact details and our team will guide you through the enrollment process.",
  },
  {
    question: "What is the course duration?",
    answer:
      "The course typically lasts for 6 months, with flexible online learning options.",
  },
  {
    question: "Are there any prerequisites?",
    answer:
      "No prior knowledge is required; the course is suitable for beginners.",
  },
  {
    question: "Will I receive a certificate?",
    answer:
      "Yes, upon completion, you will receive an IGNOU accredited certificate.",
  },
];

const CourseDetails = () => {
  const [tabValue, setTabValue] = useState(0);
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    // Scroll to section with same ID
    const section = document.getElementById(newValue);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };
  const itemVariantsLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const itemVariantsRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.5, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <>
      <Header />
      <Box
        sx={{
          backgroundImage: `url(${banner1})`,
          backgroundPosition: "center",
          backgroundRepeat: "repeat",

        }}
      >
        <Box
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          sx={{
            bgcolor: "#dde6f8",
            color: "white",
            p: { xs: 2, md: 6 },
            position: "relative",
            overflow: "hidden",
            mt:10,
          }}
        >
          <Grid container spacing={5} sx={{ position: "relative", zIndex: 1 }}>
            <Grid
              component={motion.div}
              variants={itemVariantsLeft}
              size={{ xs: 12, md: 6 }}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "95%" },
                  maxWidth: 720,
                  aspectRatio: "16/9",
                  borderRadius: 2,
                  overflow: "hidden",
                  boxShadow: 6,
                  border: "4px solid rgba(255,255,255,0.06)",
                  transformOrigin: "center",
                }}
              >
                {/* Framer motion wrapper for a subtle zoom-in loop for the video container */}
                <motion.div
                  style={{ width: "100%", height: "100%" }}
                  initial={{ scale: 1 }}
                  animate={{ scale: [1, 1.01, 1] }}
                  transition={{
                    repeat: Infinity,
                    duration: 8,
                    ease: "easeInOut",
                  }}
                >
                  <iframe
                    title="Hero YouTube video"
                    src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      width: "100%",
                      height: "100%",
                      border: 0,
                      display: "block",
                    }}
                  />
                </motion.div>
              </Box>
            </Grid>

            <Grid
              component={motion.div}
              variants={itemVariantsRight}
              size={{ xs: 12, md: 6 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              <Box>
                <Typography
                  sx={{
                    mb: 1,
                    lineHeight: 1.05,
                    color: "#0e0f10",
                    fontWeight: "bold",
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Astrology Course from IGNOU
                </Typography>

                <Typography
                  sx={{
                    color: "#333",
                    opacity: 0.95,
                    fontSize: { xs: "0.95rem", md: "1rem" },
                  }}
                >
                  Astrology in IGNOU
                </Typography>
                <Typography
                  sx={{
                    color: "#333",
                    opacity: 0.95,
                    fontSize: { xs: "0.95rem", md: "1rem" },
                    textAlign: "justify",
                    mt: 4,
                  }}
                >
                  Students can study astrology through distance learning at
                  Indira Gandhi National Open University (IGNOU) and obtain
                  comprehensive knowledge about Vedic astrology, planetary
                  movements, and horoscope analysis. The course addresses
                  students who want to learn traditional astrology, healing
                  practices, and astrological prediction methods. The astrology
                  program through IGNOU delivers educated experts, adaptable
                  online learning, and affordable costs to foster basic
                  knowledge of ancient science for students, professionals and
                  astrology fans.
                </Typography>
              </Box>

              <Box
                sx={{ display: "flex", gap: 5, alignItems: "center", mt: 1 }}
              >
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#ffc20f",
                    color: "#333",
                    fontWeight: "bold",
                    px: 3,
                    py: 1.2,
                    borderRadius: 5,
                    boxShadow: 4,
                    "&:hover": { bgcolor: "#6d1675", color: "#fff" },
                  }}
                >
                  Download Brochure
                </Button>

                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <motion.span
                    aria-hidden
                    style={{
                      position: "absolute",
                      inset: 0,
                      borderRadius: "50%",
                      background: "#189bff",
                      zIndex: -1,
                    }}
                    animate={{ scale: [1, 2], opacity: [0.6, 0] }}
                    transition={{
                      repeat: Infinity,
                      duration: 2,
                      ease: "easeOut",
                    }}
                  />

                  <motion.span
                    aria-hidden
                    style={{
                      position: "absolute",
                      inset: 0,
                      borderRadius: "50%",
                      background: "#189bff",
                      zIndex: -1,
                    }}
                    animate={{ scale: [1, 2], opacity: [0.6, 0] }}
                    transition={{
                      repeat: Infinity,
                      duration: 2,
                      ease: "easeOut",
                      delay: 1, // delay creates ripple waves
                    }}
                  />

                  <IconButton
                    aria-label="Speak"
                    size="large"
                    sx={{
                      bgcolor: "#189bff",
                      color: "white",
                      boxShadow: 3,
                      "&:hover": { bgcolor: "#1273cc" },
                    }}
                  >
                    <MicIcon />
                  </IconButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Box
            sx={{
              bgcolor: "#6d1675",
              width: "90%",
              position: "sticky",
              top: 90,
              zIndex: 1000,
              display: "flex",
              justifyContent: "center",
              mx: "auto",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabIndicatorProps={{
                style: { backgroundColor: "transparent", gap: 10 },
              }}
            >
              <Tab
                label="Overview"
                value="overview"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { color: "yellow" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="Duration & Eligibility"
                value="duration"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { color: "yellow" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="Accreditation"
                value="accreditation"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { color: "yellow" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="Curriculum"
                value="curriculum"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { color: "yellow" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="Learning"
                value="learning"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { color: "yellow" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="Fees Details"
                value="fees"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { color: "yellow" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="FAQ"
                value="faqs"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { color: "yellow" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
            </Tabs>
          </Box>

          <Box id="overview" sx={{ p: 4, bgcolor: "#ffff" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              Why Study Astrology at IGNOU?
            </Typography>
            <Typography sx={{ mb: 2, mt: -1, textAlign: "justify" }}>
              IGNOU’s astrology program exists to serve novices and
              practice-based learners looking for practical knowledge about the
              theoretical and divine characteristics of this field. Students in
              this program receive an organized educational framework that
              teaches horoscope, planetary impacts and astrological numerical
              methods.
            </Typography>
            <Typography sx={{ mb: 2, textAlign: "justify" }}>
              Working adults and Indian learners from every region can access
              the adaptive online and distance-based education format at IGNOU.
              IGNOU offers its astrology course fees at tuition rates that are
              more affordable than equivalent programs provided at private
              educational facilities so more individuals can study astrology.
              The course at IGNOU stays engaging by providing study materials
              combined with expert guidance and assignments.
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2, mt: 2 }}>
              Detailed Overview of Astrology Course in IGNOU
            </Typography>
            <Typography sx={{ mb: 2, mt: -1, textAlign: "justify" }}>
              Through IGNOU astrology education, the basics of astrology
              instruction feature aspects such as understanding planetary
              positions, reading horoscopes, and learning predictive methods.
              The astrology curriculum teaches different astrological customs
              while teaching students actual Vedic astrological methods.
            </Typography>
            <Typography sx={{ mb: 2, textAlign: "justify" }}>
              Students can effectively manage their academic workload with
              additional personal obligations through their distance and online
              learning format. This program provides students with both
              practical components and project-based work to develop their
              knowledge for real-life applications.
            </Typography>
          </Box>
          <Box id="duration" sx={{ px: 4, mt: -2 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              Benefits of Online & Distance Astrology Course in IGNOU
            </Typography>
            <List sx={{ mt: -2 }}>
              {highlights.map((item, index) => (
                <ListItem
                  key={index}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#333",
                      mr: 1,
                      fontSize: 15,

                      // minWidth: 180,
                    }}
                  >
                    {item.title} –
                  </Typography>
                  <Typography sx={{ color: "#555", fontSize: 15 }}>
                    {item.desc}
                  </Typography>
                </ListItem>
              ))}
            </List>
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 2, fontSize: { xs: 20, md: 30 } }}
            >
              Eligibility for Astrology Course in IGNOU
            </Typography>
            <Typography>
              Before beginning the astrology course at IGNOU students need to
              graduate from 10+2 education at any recognized educational
              institution. The program welcomes participants of any age since it
              embraces astrology students, college students and working adults.
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                mb: 2,
                mt: 2,
                fontSize: { xs: 20, md: 30 },
              }}
            >
              Benefits of Online & Distance Astrology Course in IGNOU
            </Typography>
            <List sx={{ mt: -2 }}>
              {highlights.map((item, index) => (
                <ListItem
                  key={index}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#333",
                      mr: 1,
                      fontSize: 15,

                      // minWidth: 180,
                    }}
                  ></Typography>
                  <Typography sx={{ color: "#555", fontSize: 15 }}>
                    {item.title} – {item.desc}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Box>
          <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            id="accreditation"
            sx={{ p: 4, textAlign: "center" }}
          >
            <Typography
              sx={{ fontWeight: "bold", mb: 2, fontSize: { xs: 20, md: 30 } }}
            >
              IGNOU Accreditation for Online & Distance Astrology Course in
              IGNOU
            </Typography>
            <Grid
              container
              spacing={5}
              sx={{ position: "relative", zIndex: 1 }}
            >
              <Grid
                component={motion.div}
                variants={itemVariantsLeft}
                size={{ xs: 12, md: 6 }}
                sx={{ mt: 3 }}
              >
                <img
                  src={image}
                  alt=""
                  style={{ width: "100%", height: "auto", borderRadius: 20 }}
                />
              </Grid>

              <Grid
                component={motion.div}
                variants={itemVariantsRight}
                size={{ xs: 12, md: 6 }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
              >
                <Box
                  sx={{
                    gap: 1,
                    mt: 3,
                    display: "grid",
                    width: { xs: "100%", md: "90%" },
                  }}
                >
                  {accreditations.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        gap: 2,
                        textAlign: "left",
                        p: 1,
                        border: "1px solid #d3d3d3",
                        bgcolor: "#f0f0f0",
                        borderRadius: 3,
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={item.img}
                        alt={item.title}
                        style={{ width: 60, height: 60 }}
                      />
                      <Box>
                        <Typography sx={{ fontWeight: "bold" }}>
                          {item.title}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }}>
                          {item.desc}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box id="learning" sx={{ p: 4, textAlign: "center" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 4 }}>
              IGNOU Learning Methodology
            </Typography>

            <Grid container justifyContent="center">
              {learningItems.map((item, index) => (
                <Grid size={{ xs: 6, sm: 4, md: 2 }} key={index}>
                  <motion.div
                    variants={cardVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                  >
                    <Box
                      sx={{
                        width: 150,
                        height: 150,
                        mx: "auto",
                        borderRadius: "50%",

                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={item.img}
                        alt={item.title}
                        style={{ width: "60%", height: "60%" }}
                      />
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.95rem",
                        width: 120,
                        mx: "auto",
                      }}
                    >
                      {item.title}
                    </Typography>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box id="fees" sx={{ p: 4 }}>
            <Box
              sx={{
                position: "relative",
                backgroundImage: `url(${banner2})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: 3,
                height: 300,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  bgcolor: "rgba(0, 0, 0, 0.5)",
                  borderRadius: 3,
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: "center",
                  justifyContent: { xs: "center", md: "space-between" },
                  px: 4,
                  color: "#fff",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 1,
                      fontSize: { xs: 22, md: 30 },
                    }}
                  >
                    Still have any queries related to the IGNOU Online &
                    <br /> Distance Astrology course?
                  </Typography>
                  <Typography sx={{ fontSize: 15 }}>
                    Submit your contact details, and our IGNOU expert team will
                    call you and provide all the details for free
                  </Typography>
                </Box>

                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#ffc20f",
                    color: "#333",
                    fontWeight: "bold",
                    px: 3,
                    py: 1.2,
                    borderRadius: 5,
                    textTransform: "none",
                    ml: { xs: 0, md: 20 },
                    boxShadow: 4,
                    "&:hover": { bgcolor: "#6d1675", color: "#fff" },
                  }}
                >
                  Get Fees Consultation
                </Button>
              </Box>
            </Box>
          </Box>
          <Box id="faqs" sx={{ px: 6, py: 4 }}>
            <Typography
              sx={{
                mb: 3,
                fontWeight: "bold",
                textAlign: "center",
                fontSize: { xs: 20, md: 30 },
              }}
            >
              FAQ’s About Astrology Course from IGNOU
            </Typography>

            {faqData.map((faq, index) => (
              <Box key={index} sx={{ width: "95%" }}>
                <Accordion
                  expanded={expanded === `panel${index}`}
                  onChange={handleChanges(`panel${index}`)}
                  sx={{
                    bgcolor: "transparent",
                    boxShadow: "none",

                    "&:before": { display: "none" },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === `panel${index}` ? (
                        <RemoveIcon />
                      ) : (
                        <AddIcon />
                      )
                    }
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        mb: 1,
                        mt: 1,
                        fontSize: { xs: 14, md: 16 },
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography sx={{ fontSize: { xs: 13, md: 15 } }}>
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                {index < faqData.length - 1 && (
                  <Divider sx={{ bgcolor: "#ccc" }} />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default CourseDetails;

